import {useAppSelector} from 'core/redux/hooks/useAppSelector';
import {FormikProps} from 'formik/dist/types';
import {actionSetNewOrder} from 'modules/checkout/slice';
import {ICheckoutValues} from 'modules/checkout/types';
import {selectErrorsByModuleName} from 'modules/errors/selectors';
import {useCallback, useEffect} from 'react';

export const useCheckoutErrorsMounting = (formikProps: FormikProps<ICheckoutValues> | null) => {
    const errorsByModuleList = useAppSelector(selectErrorsByModuleName(actionSetNewOrder.type));

    const setErrors = useCallback(() => {
        errorsByModuleList?.forEach((error) => {
            if (error.field && error.message) {
                formikProps?.setFieldError(error.field, error.message);
            }
        });
    }, [errorsByModuleList, formikProps]);

    useEffect(() => {
        if (errorsByModuleList?.length) {
            setErrors();
        }
    }, [errorsByModuleList?.length, setErrors]);
};
